module.exports = __webpack_public_path__ + "img/Storage.334e6c76.svg";